import type { AttackAnimation, Bomb, EntityId, Shield, Weapon } from '../types';
import { SkillType } from '../model/skills';
import { dmg } from '../model/game';

const disabled = true;

export const animations: Record<AttackAnimation, number[]> = {
  swing_pickaxe: [1.4], // verified
  spear_throw: [1.57],
  spear_poke: [0.68], // 0.433 -> 0.468
  throw_bomb: [0.95],
  knife_stab: [0.6, 0.44, 0.7], // 0.533, 0.667, 0.933
  knife_secondary: [1.52],
  dual_knives: [0.54, 0.46, 0.72],
  dual_knives_secondary: [1.66],
  swing_axe: [0.78, 0.7, 1.12], // 0.56, 1.30, 2.00    4.20, 4.93, 5.46, 6.50   1.26, 2.13, 2.83, 4.00
  axe_secondary: [2],
  unarmed_attack: [0.76, 0.76],
  unarmed_kick: [1.51], // 1.9 / 1.2
  swing_sledge: [2.12], // 2.23
  swing_longsword: [1.14, 0.44, 0.88], // 1.2, 0.9, 0.867
  sword_secondary: [1.84],
  greatsword: [0.72, 1.12, 1.61], // 1.233, 1.067, 1.567
  greatsword_secondary: [2.16],
  mace_secondary: [1.72],
  battleaxe_attack: [1.58, 0.92, 0.7],
  battleaxe_secondary: [0.84],
  atgeir_attack: [0.84, 0.86, 1.28],
  atgeir_secondary: [1.54],
  bow_fire: [0.83],
  crossbow_fire: [0.83],
  staff_rapidfire: [0.2],
  staff_fireball: [2],
  staff_summon: [2],
  dualaxes: [NaN],
  dualaxes_secondary: [NaN],
  recharge_lightningstaff: [1.9],
};
// bow_aim_recoil: 21


function variations(main: Weapon, options: Record<EntityId, Partial<Weapon>>): Weapon[] {
  return [
    main,
    ...Object.entries(options)
      .map(([id, override]) => ({ ...main, id, ...override }))
  ];
}

export const items: (Weapon | Shield | Bomb)[] = [
// PRE-CRAFT AGE
  {
    type: 'weapon', slot: 'both',
    id: 'PlayerUnarmed',
    emoji: '👊',
    tier: 0,
    stack: 0,
    maxLvl: 1,
    weight: 0,
    moveSpeed: 0,
    block: 2,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Unarmed,
    damage: [dmg({ blunt: 5 }), dmg({})],
    knockback: 40,
    backstab: 4,
    attacks: [{
      type: 'melee',
      animation: 'unarmed_attack',
      chain: 2,
      chainCombo: 1,
      stamina: 4,
      walkSpeed: 0.1,
      rotationSpeed: 0.5,
      startNoise: 5,
      hitNoise: 20,
      range: 1.5,
    }, {
      type: 'melee',
      animation: 'unarmed_kick',
      chain: 0,
      chainCombo: 1,
      stamina: 8,
      walkSpeed: 0,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 1.6,
      mul: { damage: 1, force: 4, stagger: 6 },
    }],
    durability: [Infinity, 0],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'Tankard',
    emoji: '🍺',
    tier: 2,
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 4,
    parryForce: [5, 0],
    parryBonus: 1.5,
    skill: null,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 4,
    attacks: [],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'TankardOdin',
    dlc: 'beta',
    emoji: '📯',
    tier: 2,
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 4,
    parryForce: [5, 0],
    parryBonus: 1.5,
    skill: null,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 4,
    attacks: [],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'TankardAnniversary',
    emoji: '📯',
    tier: 2,
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 4,
    parryForce: [5, 0],
    parryBonus: 1.5,
    skill: null,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 4,
    attacks: [],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'Tankard_dvergr',
    emoji: '🍺',
    tier: 2,
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 4,
    parryForce: [5, 0],
    parryBonus: 1.5,
    skill: null,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 4,
    attacks: [],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'Club',
    emoji: '🏏',
    tier: 0,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 12 }), dmg({ blunt: 6 })],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 6,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeStone',
    emoji: '🪓',
    tier: 0,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 0,
    damage: [
      dmg({ slash: 15, chop: 20 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_axe',
      chain: 3,
      chainCombo: 2,
      stamina: 6,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
    }, {
      type: 'melee',
      animation: 'axe_secondary',
      chain: 0,
      chainCombo: 0,
      stamina: 12,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
      mul: { damage: 1.5, force: 1.5, stagger: 1, },
    }],
    durability: [100, 30],
  },
  {
    type: 'weapon', slot: 'either',
    id: 'Torch',
    // lightRadius: 2,
    PointLight: {
      color: '#FF9E7B',
      range: 10,
      intensity: 1.5,
    },
    emoji: '🔥',
    tier: 0,
    tags: ['fire'],
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 4, fire: 15 }), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 4,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }],
    durability: [20, 0],
    durabilityDrainPerSec: 30,
  },
  {
    type: 'weapon', slot: 'either',
    id: 'Sparkler',
    // lightRadius: 2,
    emoji: '🎇',
    tier: 1,
    tags: ['fire'],
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [],
    durability: [8, 0],
    durabilityDrainPerSec: 30,
  },
// STONE AGE
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeFlint',
    emoji: '🪓',
    tier: 1,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 4,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 1,
    damage: [
      dmg({ slash: 20, chop: 30 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_axe',
      chain: 3,
      chainCombo: 2,
      stamina: 6,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
    }, {
      type: 'melee',
      animation: 'axe_secondary',
      chain: 0,
      chainCombo: 0,
      stamina: 6,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
      mul: { damage: 1.5, force: 1.5, stagger: 1, },
    }],
    durability: [100, 30],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeFlint',
    emoji: '🔪',
    tier: 1,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 5, pierce: 5 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [{
      type: 'melee',
      animation: 'knife_stab',
      chain: 3,
      chainCombo: 2,
      stamina: 4,
      walkSpeed: 0.3,
      rotationSpeed: 1,
      startNoise: 1,
      hitNoise: 5,
      range: 1.8,
    }, {
      type: 'melee',
      animation: 'knife_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 12,
      walkSpeed: 0,
      rotationSpeed: 0,
      startNoise: 2,
      hitNoise: 5,
      range: 1.8,
      mul: { damage: 3, force: 4, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearFlint',
    emoji: '🍢',
    tier: 1,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 4,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 20 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'spear_poke',
      chain: 0,
      chainCombo: 1,
      stamina: 6,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 1.9,
    }, {
      type: 'proj',
      animation: 'spear_throw',
      projVel: [2, 20],
      projAcc: [20, 1],
      stamina: 8,
      walkSpeed: 0.3,
      rotationSpeed: 5,
      startNoise: 10,
      hitNoise: 30,
      range: 1,
      mul: { damage: 1.5, force: 1.5, stagger: 1 },
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'SledgeStagbreaker',
    emoji: '🔨',
    tier: 1,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.2,
    block: 4,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [
      dmg({ blunt: 20, pierce: 5 }),
      dmg({ blunt: 6 }),
    ],
    knockback: 150,
    backstab: 2,
    attacks: [{
      type: 'area',
      animation: 'swing_sledge',
      stamina: 12,
      walkSpeed: 0.3,
      rotationSpeed: 0.1,
      startNoise: 10,
      hitNoise: 60,
      range: 2,
      radius: 5,
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'Bow',
    emoji: '🏹',
    tier: 1,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [dmg({ pierce: 22 }), dmg({ pierce: 3 })],
    knockback: 0,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 35],
      projAcc: [20, 1],
      stamina: 0,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
    }],
    durability: [50, 50],
    holdDurationMin: 2.5,
    holdStaminaDrain: 4,
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeStone',
    emoji: '⛏️',
    disabled,
    tier: -1,
    stack: 1,
    maxLvl: 1,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: 0,
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 0,
    damage: [dmg({ pierce: 15, pickaxe: 15 }), dmg({})],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_pickaxe',
      chain: 0,
      chainCombo: 2,
      stamina: 4,
      walkSpeed: 0.1,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 1.8,
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeAntler',
    emoji: '⛏️',
    tier: 1,
    stack: 1,
    maxLvl: 1,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 0,
    damage: [dmg({ pierce: 18, pickaxe: 18 }), dmg({})],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_pickaxe',
      chain: 0,
      chainCombo: 2,
      stamina: 6,
      walkSpeed: 0.1,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 1.8,
    }],
    durability: [100, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldWood',
    emoji: '🛡️',
    tier: 1,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 4,
    weight: 4,
    moveSpeed: -0.05,
    block: [6, 6],
    parryForce: [20, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldWoodTower',
    emoji: '🛡️',
    floating: true,
    tier: 1,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 4,
    moveSpeed: -0.2,
    block: [10, 6],
    parryForce: [100, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
// BRONZE AGE
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeCopper',
    emoji: '🔪',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 12, pierce: 12 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [{
      type: 'melee',
      animation: 'knife_stab',
      chain: 3,
      chainCombo: 2,
      stamina: 6,
      walkSpeed: 0.3,
      rotationSpeed: 1,
      startNoise: 1,
      hitNoise: 5,
      range: 1.8,
    }, {
      type: 'melee',
      animation: 'knife_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 18,
      walkSpeed: 0,
      rotationSpeed: 0,
      startNoise: 2,
      hitNoise: 5,
      range: 1.8,
      mul: { damage: 3, force: 4, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AtgeirBronze',
    emoji: '🔱',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.05,
    block: 16,
    parryForce: [40, 5],
    parryBonus: 2,
    skill: SkillType.Polearms,
    damage: [dmg({ pierce: 45 }), dmg({ pierce: 6 })],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'atgeir_attack',
      chain: 3,
      chainCombo: 2,
      stamina: 12,
      walkSpeed: 0.2,
      rotationSpeed: 0.5,
      startNoise: 20,
      hitNoise: 30,
      range: 3.2,
    }, {
      type: 'melee',
      animation: 'atgeir_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 24,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 3,
      mul: { damage: 1, force: 5, stagger: 6 },
    }],
    durability: [125, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeBronze',
    emoji: '🪓',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 2,
    damage: [
      dmg({ slash: 40, chop: 40 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_axe',
      chain: 3,
      chainCombo: 2,
      stamina: 8,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
    }, {
      type: 'melee',
      animation: 'axe_secondary',
      chain: 3,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
      mul: { damage: 1.5, force: 1.5, stagger: 1, },
    }],
    durability: [125, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'MaceBronze',
    emoji: '🏏',
    tier: 2,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [30, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 35 }), dmg({ blunt: 6 })],
    knockback: 80,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 8,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'mace_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.5,
      mul: { damage: 2.5, force: 2, stagger: 2 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearBronze',
    emoji: '🍢',
    tier: 2,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 35 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'spear_poke',
      chain: 0,
      chainCombo: 2,
      stamina: 8,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 1.9,
    }, {
      type: 'proj',
      animation: 'spear_throw',
      projVel: [2, 20],
      projAcc: [20, 1],
      stamina: 10,
      walkSpeed: 0.3,
      rotationSpeed: 5,
      startNoise: 10,
      hitNoise: 30,
      range: 1,
      mul: { damage: 1.5, force: 1.5, stagger: 1 },
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordBronze',
    emoji: '🗡️',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [dmg({ slash: 35 }), dmg({ slash: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 8,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'sword_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.7,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeBronze',
    emoji: '⛏️',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 1,
    damage: [
      dmg({ pierce: 25, pickaxe: 25 }),
      dmg({ pierce: 5, pickaxe: 4 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_pickaxe',
      chain: 0,
      chainCombo: 2,
      stamina: 8,
      walkSpeed: 0.1,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 1.8,
    }],
    durability: [120, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'BowFineWood',
    emoji: '🏹',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    floating: true,
    skill: SkillType.Bows,
    damage: [dmg({ pierce: 32 }), dmg({ pierce: 3 })],
    knockback: 5,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 50],
      projAcc: [20, 1],
      stamina: 0,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
    }],
    durability: [100, 50],
    holdDurationMin: 2.5,
    holdStaminaDrain: 6,
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBronzeBuckler',
    emoji: '🛡️',
    tier: 2,
    stack: 1,
    maxLvl: 3,
    weight: 3,
    moveSpeed: -0.05,
    block: [16, 6],
    parryForce: 30,
    parryBonus: 2.5,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBoneTower',
    emoji: '🛡️',
    floating: true,
    tier: 2,
    stack: 1,
    maxLvl: 3,
    weight: 4,
    moveSpeed: -0.2,
    block: [32, 6],
    parryForce: [100, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
// IRON AGE
  {
    type: 'bomb', slot: 'primary',
    id: 'BombOoze',
    emoji: '💣',
    tier: 3,
    stack: 50,
    maxLvl: 1,
    weight: 0.3,
    // radius: 4, ttl: 10, interval: 1
    // oozebomb_projectile
    spawns: 'oozebomb_explosion',
    stamina: 8,
  },
  {
    type: 'weapon', slot: 'both',
    id: 'Battleaxe',
    emoji: '🪓',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.2,
    block: 28,
    parryForce: [70, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 3,
    damage: [
      dmg({ slash: 70, chop: 40 }),
      dmg({ slash: 6, chop: 2.5 }),
    ],
    knockback: 70,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'battleaxe_attack',
      chain: 3,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.1,
      rotationSpeed: 0.3,
      startNoise: 20,
      hitNoise: 30,
      range: 2.5,
      mul: { damage: 1, force: 1, stagger: 1.5 },
    }, {
      type: 'melee',
      animation: 'battleaxe_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 8,
      walkSpeed: 0.1,
      rotationSpeed: 0.1,
      startNoise: 10,
      hitNoise: 30,
      range: 2.5,
      mul: { damage: 0.5, force: 2, stagger: 4 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordIron',
    // lightRadius: 2,
    emoji: '🗡️',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    toolTier: 0,
    damage: [dmg({ slash: 55 }), dmg({ slash: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 10,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'sword_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 20,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.7,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeIron',
    emoji: '🪓',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 3,
    damage: [
      dmg({ slash: 60, chop: 50 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_axe',
      chain: 3,
      chainCombo: 2,
      stamina: 10,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
    }, {
      type: 'melee',
      animation: 'axe_secondary',
      chain: 3,
      chainCombo: 2,
      stamina: 20,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
      mul: { damage: 1.5, force: 1.5, stagger: 1, },
    }],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'SledgeIron',
    emoji: '🔨',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.2,
    block: 28,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 55 }), dmg({ blunt: 6 })],
    knockback: 200,
    backstab: 2,
    attacks: [{
      type: 'area',
      animation: 'swing_sledge',
      stamina: 20,
      walkSpeed: 0.3,
      rotationSpeed: 0.1,
      startNoise: 10,
      hitNoise: 60,
      range: 2,
      mul: { damage: 1, force: 1, stagger: 2 },
      radius: 5,
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'MaceIron',
    emoji: '🏏',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [30, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 55 }), dmg({ blunt: 6 })],
    knockback: 90,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 10,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'mace_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 20,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.5,
      mul: { damage: 2.5, force: 2, stagger: 2 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearElderbark',
    emoji: '🍢',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 55 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'spear_poke',
      chain: 0,
      chainCombo: 2,
      stamina: 10,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 1.9,
    }, {
      type: 'proj',
      animation: 'spear_throw',
      projVel: [2, 20],
      projAcc: [20, 1],
      stamina: 12,
      walkSpeed: 0.3,
      rotationSpeed: 5,
      startNoise: 10,
      hitNoise: 30,
      range: 1,
      mul: { damage: 1.5, force: 1.5, stagger: 1 },
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeIron',
    emoji: '⛏️',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 2,
    damage: [
      dmg({ pierce: 33, pickaxe: 33 }),
      dmg({ pierce: 5, pickaxe: 5 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_pickaxe',
      chain: 0,
      chainCombo: 2,
      stamina: 10,
      walkSpeed: 0.1,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 1.8,
    }],
    durability: [150, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'AtgeirIron',
    emoji: '🔱',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.05,
    block: 28,
    parryForce: [40, 5],
    parryBonus: 2,
    skill: SkillType.Polearms,
    damage: [dmg({ pierce: 65 }), dmg({ pierce: 6 })],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'atgeir_attack',
      chain: 3,
      chainCombo: 2,
      stamina: 14,
      walkSpeed: 0.2,
      rotationSpeed: 0.5,
      startNoise: 20,
      hitNoise: 30,
      range: 3.2,
    }, {
      type: 'melee',
      animation: 'atgeir_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 28,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 3,
      mul: { damage: 1, force: 5, stagger: 6 },
    }],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'BowHuntsman',
    emoji: '🏹',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [dmg({ pierce: 42 }), dmg({ pierce: 3 })],
    knockback: 10,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 50],
      projAcc: [20, 0],
      stamina: 0,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 4,
      hitNoise: 4,
      range: 1,
    }],
    durability: [100, 50],
    holdDurationMin: 2.5,
    holdStaminaDrain: 8,
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBanded',
    emoji: '🛡️',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 4,
    weight: 5,
    moveSpeed: -0.05,
    block: [42, 6],
    parryForce: [40, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldIronTower',
    emoji: '🛡️',
    floating: true,
    tier: 3,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 4,
    moveSpeed: -0.2,
    block: [52, 6],
    parryForce: [100, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    durability: [200, 50],
    knockback: 40,
    backstab: 4,
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldIronBuckler',
    emoji: '🛡️',
    floating: true,
    tier: 3,
    stack: 1,
    maxLvl: 3,
    weight: 4,
    moveSpeed: -0.05,
    block: [28, 6],
    parryForce: 30,
    parryBonus: 2.5,
    skill: SkillType.Blocking,
    durability: [200, 50],
    knockback: 40,
    backstab: 4,
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldSerpentscale',
    emoji: '🛡️',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 3,
    weight: 5,
    moveSpeed: -0.15,
    block: [60, 6],
    parryForce: [100, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    damageModifiers: { pierce: 'resistant' },
    durability: [250, 50],
    knockback: 50,
    backstab: 4,
  },
// SILVER AGE
  {
    type: 'weapon', slot: 'both',
    id: 'FistFenrirClaw',
    emoji: '🍴',
    tier: 4,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: 0,
    block: [5, 1],
    parryForce: [10, 5],
    parryBonus: 6,
    skill: SkillType.Unarmed,
    toolTier: 0,
    damage: [
      dmg({ slash: 60 }),
      dmg({ slash: 4 }),
    ],
    knockback: 20,
    backstab: 6,
    attacks: [{
      type: 'melee',
      animation: 'unarmed_attack',
      chain: 2,
      chainCombo: 2,
      stamina: 10,
      walkSpeed: 0.3,
      rotationSpeed: 1,
      startNoise: 1,
      hitNoise: 5,
      range: 2,
    }, {
      type: 'melee',
      animation: 'unarmed_kick',
      chain: 0,
      chainCombo: 2,
      stamina: 20,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 2.5,
      mul: { damage: 1, force: 4, stagger: 6 },
    }],
    durability: [300, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'BattleaxeCrystal',
    emoji: '🪓',
    tier: 4,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    PointLight: { color: '#A8D3FF', range: 3, intensity: 1 },
    moveSpeed: -0.2,
    block: 40,
    parryForce: [70, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 3,
    damage: [
      dmg({ slash: 90, chop: 50, spirit: 30 }),
      dmg({ slash: 6, chop: 2.5 }),
    ],
    knockback: 70,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'battleaxe_attack',
      chain: 3,
      chainCombo: 2,
      stamina: 18,
      walkSpeed: 0.1,
      rotationSpeed: 0.3,
      startNoise: 20,
      hitNoise: 30,
      range: 2.5,
      mul: { damage: 1, force: 1, stagger: 1.5 },
    }, {
      type: 'melee',
      animation: 'battleaxe_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 9,
      walkSpeed: 0.1,
      rotationSpeed: 0.1,
      startNoise: 10,
      hitNoise: 30,
      range: 2.5,
      mul: { damage: 0.5, force: 2, stagger: 4 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordSilver',
    emoji: '🗡️',
    tier: 4,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    moveSpeed: -0.05,
    block: 30,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [
      dmg({ slash: 75, spirit: 30 }),
      dmg({ slash: 6, spirit: 5 }),
    ],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 12,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'sword_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 24,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.7,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearWolfFang',
    emoji: '🍢',
    tier: 4,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 30,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 75 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'spear_poke',
      chain: 0,
      chainCombo: 2,
      stamina: 12,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 1.9,
    }, {
      type: 'proj',
      animation: 'spear_throw',
      projVel: [2, 20],
      projAcc: [20, 1],
      stamina: 14,
      walkSpeed: 0.3,
      rotationSpeed: 5,
      startNoise: 10,
      hitNoise: 30,
      range: 1,
      mul: { damage: 1.5, force: 1.5, stagger: 1 },
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'MaceSilver',
    emoji: '🔨',
    tier: 4,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 30,
    parryForce: [30, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [
      dmg({ blunt: 35, frost: 40, spirit: 20 }),
      dmg({ frost: 6 }),
    ],
    knockback: 120,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      stamina: 12,
      range: 2.4,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      chainCombo: 2,
    }, {
      type: 'melee',
      animation: 'mace_secondary',
      chain: 0,
      stamina: 24,
      range: 2.5,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      mul: { damage: 2.5, force: 2, stagger: 2, },
      chainCombo: 2,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearChitin',
    emoji: '🍢',
    tier: 2,
    floating: true,
    special: 'harpoon',
    stack: 1,
    maxLvl: 1,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 10 }), dmg({})],
    knockback: 20,
    backstab: 1,
    attacks: [{
      type: 'proj',
      animation: 'spear_throw',
      projVel: [2, 30],
      projAcc: [20, 0],
      stamina: 15,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 30,
      range: 1,
    }],
    durability: [50, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeChitin',
    emoji: '🔪',
    tier: 2,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 20, pierce: 20 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [{
      type: 'melee',
      animation: 'knife_stab',
      chain: 3,
      chainCombo: 2,
      stamina: 8,
      walkSpeed: 0.3,
      rotationSpeed: 1,
      startNoise: 1,
      hitNoise: 5,
      range: 1.8,
    }, {
      type: 'melee',
      animation: 'knife_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 24,
      walkSpeed: 0,
      rotationSpeed: 0,
      startNoise: 2,
      hitNoise: 5,
      range: 1.8,
      mul: { damage: 3, force: 4, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeSilver',
    emoji: '🔪',
    tier: 4,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 25, pierce: 25, spirit: 12 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [{
      type: 'melee',
      animation: 'knife_stab',
      chain: 3,
      chainCombo: 2,
      stamina: 10,
      walkSpeed: 0.3,
      rotationSpeed: 1,
      startNoise: 1,
      hitNoise: 5,
      range: 1.8,
    }, {
      type: 'melee',
      animation: 'knife_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 30,
      walkSpeed: 0,
      rotationSpeed: 0,
      startNoise: 2,
      hitNoise: 5,
      range: 1.8,
      mul: { damage: 3, force: 4, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'BowDraugrFang',
    emoji: '🏹',
    tier: 4,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [
      dmg({ pierce: 47, poison: 5 }),
      dmg({ pierce: 3, poison: 5 }),
    ],
    knockback: 20,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 60],
      projAcc: [20, 0],
      stamina: 0,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
    }],
    durability: [100, 50],
    holdDurationMin: 2.5,
    holdStaminaDrain: 10,
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldSilver',
    emoji: '🛡️',
    tier: 4,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 5,
    moveSpeed: -0.05,
    block: [60, 6],
    parryForce: [40, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
// BLACK AGE
  {
    type: 'weapon', slot: 'both',
    id: 'AtgeirBlackmetal',
    emoji: '🔱',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.05,
    block: 52,
    parryForce: [40, 5],
    parryBonus: 2,
    skill: SkillType.Polearms,
    damage: [dmg({ pierce: 105 }), dmg({ pierce: 6 })],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'atgeir_attack',
      chain: 3,
      chainCombo: 2,
      stamina: 18,
      walkSpeed: 0.2,
      rotationSpeed: 0.5,
      startNoise: 20,
      hitNoise: 30,
      range: 3.2,
    }, {
      type: 'melee',
      animation: 'atgeir_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 36,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 3,
      mul: { damage: 1, force: 5, stagger: 6 },
    }],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeBlackMetal',
    emoji: '🪓',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 39,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 4,
    damage: [
      dmg({ slash: 100, chop: 60 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 60,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_axe',
      chain: 3,
      chainCombo: 2,
      stamina: 14,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
    }, {
      type: 'melee',
      animation: 'axe_secondary',
      chain: 0,
      chainCombo: 0,
      stamina: 28,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
      mul: { damage: 1.5, force: 1.5, stagger: 1, },
    }],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeBlackMetal',
    emoji: '⛏️',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 3,
    damage: [
      dmg({ pierce: 49, pickaxe: 49 }),
      dmg({ pierce: 5, pickaxe: 5 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_pickaxe',
      chain: 0,
      chainCombo: 2,
      stamina: 14,
      walkSpeed: 0.1,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 1.8,
    }],
    durability: [210, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeBlackMetal',
    emoji: '🔪',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 34, pierce: 34 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [{
      type: 'melee',
      animation: 'knife_stab',
      chain: 3,
      chainCombo: 2,
      stamina: 12,
      walkSpeed: 0.3,
      rotationSpeed: 1,
      startNoise: 1,
      hitNoise: 5,
      range: 1.8,
    }, {
      type: 'melee',
      animation: 'knife_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 36,
      walkSpeed: 0,
      rotationSpeed: 0,
      startNoise: 2,
      hitNoise: 5,
      range: 1.8,
      mul: { damage: 3, force: 4, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordBlackmetal',
    emoji: '🗡️',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    moveSpeed: -0.05,
    block: 39,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [dmg({ slash: 95 }), dmg({ slash: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 14,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'sword_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 28,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.7,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'MaceNeedle',
    emoji: '🏏',
    tier: 5,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    PointLight: { color: '#38FFC5', range: 3, intensity: 1 },
    moveSpeed: -0.05,
    block: 39,
    parryForce: [30, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [
      dmg({ blunt: 50, pierce: 45 }),
      dmg({ pierce: 6 }),
    ],
    knockback: 100,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 14,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'mace_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 28,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.5,
      mul: { damage: 2.5, force: 2, stagger: 2 },
    }],
    durability: [150, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'BowSpineSnap',
    PointLight: { color: '#DB1827', range: 7, intensity: 1.2 },
    emoji: '🏹',
    tier: 6,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [
      dmg({ pierce: 72, spirit: 5 }),
      dmg({ pierce: 4, spirit: 5 }),
    ],
    knockback: 25,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 60],
      projAcc: [20, 0],
      stamina: 0,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
    }],
    durability: [100, 50],
    holdDurationMin: 2.5,
    holdStaminaDrain: 14,
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'CrossbowArbalest',
    emoji: '🏹',
    tier: 5,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Crossbows,
    damage: [
      dmg({ pierce: 200 }),
      dmg({ pierce: 3 }),
    ],
    knockback: 200,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'crossbow_fire',
      projVel: [0, 200],
      projAcc: [1, 0],
      stamina: 0,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
    }],
    durability: [50, 50],
    holdDurationMin: 3.5,
    holdStaminaDrain: 1,
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBlackmetal',
    emoji: '🛡️',
    tier: 5,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 5,
    moveSpeed: -0.05,
    block: [78, 6],
    parryForce: [50, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBlackmetalTower',
    emoji: '🛡️',
    tier: 5,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 5,
    moveSpeed: -0.2,
    block: [104, 6],
    parryForce: [150, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
// MISTLANDS
  {
    type: 'bomb', slot: 'primary',
    id: 'BombBile',
    emoji: '💣',
    tier: 6,
    stack: 50,
    weight: 0.3,
    // bilebomb_projectile
    // bilebomb_explosion
    spawns: 'bilebomb_explosion',
    stamina: 8,
  },
  {
    type: 'weapon', slot: 'either',
    id: 'Lantern',
    group: 'torch',
    emoji: '🏮',
    tier: 6,
    tags: ['fire'],
    stack: 1,
    maxLvl: 1,
    weight: 2,
    PointLight: { color: '#FFC849', range: 8, intensity: 1.5 },
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 4, fire: 15 }), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [],
    durability: [200, 0],
  },
  {
    type: 'weapon', slot: 'either',
    id: 'TorchMist',
    disabled,
    PointLight: { color: '#7BCDFF', range: 10, intensity: 1.5 },
    demister: 6,
    // warmthRadius: 2,
    group: 'demist',
    emoji: '🔥',
    tier: 6,
    tags: ['fire'],
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 4, fire: 15 }), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 4,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }],
    durability: [20, 0],
    durabilityDrainPerSec: 30,
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffIceShards',
    emoji: '❄',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    PointLight: { color: '#2AE2FF', range: 3, intensity: 1.5 },
    moveSpeed: -0.10,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    damage: [dmg({ frost: 30 }), dmg({ frost: 2 })],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'staff_rapidfire',
      projVel: [30, 30],
      projAcc: [5, 0],
      raiseSkillAmount: 0.2,
      stamina: 0,
      eitr: 5,
      walkSpeed: 0.5,
      rotationSpeed: 1,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffFireball',
    emoji: '🔥',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    PointLight: { color: '#FF762A', range: 3, intensity: 1.5 },
    moveSpeed: -0.10,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    damage: [dmg({ fire: 60, blunt: 40 }), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'staff_fireball',
      projVel: [30, 30],
      projAcc: [5, 0],
      stamina: 0,
      eitr: 35,
      walkSpeed: 0.5,
      rotationSpeed: 1,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffSkeleton',
    emoji: '💀',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    PointLight: { color: '#DC25E2', range: 4, intensity: 1 },
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 1.5,
    skill: SkillType.BloodMagic,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'summon',
      animation: 'staff_summon',
      stamina: 0,
      eitr: 100,
      healthPercent: 40,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
      summons: 'Skeleton_Friendly',
      skillFactor: 0.02,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffShield',
    emoji: '🛡',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 1.5,
    skill: SkillType.BloodMagic,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'cast',
      animation: 'staff_summon',
      stamina: 0,
      eitr: 60,
      healthPercent: 40,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
      id: 'Staff_shield',
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'AtgeirHimminAfl',
    emoji: '🔱',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    // always, not only equipped:
    PointLight: { color: '#3AB9D6', range: 7, intensity: 1 },
    moveSpeed: -0.05,
    block: 64,
    parryForce: [40, 5],
    parryBonus: 2,
    skill: SkillType.Polearms,
    damage: [dmg({ pierce: 85, lightning: 40 }), dmg({ lightning: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'atgeir_attack',
      chain: 3,
      chainCombo: 2,
      stamina: 20,
      walkSpeed: 0.2,
      rotationSpeed: 0.5,
      startNoise: 20,
      hitNoise: 30,
      range: 3.2,
    }, {
      type: 'melee',
      animation: 'atgeir_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 40,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 3,
      mul: { damage: 1, force: 5, stagger: 6 },
    }],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeJotunBane',
    emoji: '🪓',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    PointLight: { color: '#DBAA18', range: 7, intensity: 1 },
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 4,
    damage: [
      dmg({ slash: 80, chop: 70, poison: 40 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 60,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_axe',
      chain: 3,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
    }, {
      type: 'melee',
      animation: 'axe_secondary',
      chain: 0,
      chainCombo: 0,
      stamina: 32,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
      mul: { damage: 1.5, force: 1.5, stagger: 1, },
    }],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'KnifeSkollAndHati',
    emoji: '🔪',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 24,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 45, pierce: 45 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [{
      type: 'melee',
      animation: 'dual_knives',
      chain: 3,
      chainCombo: 2,
      stamina: 14,
      walkSpeed: 0.3,
      rotationSpeed: 1,
      startNoise: 1,
      hitNoise: 5,
      range: 1.8,
    }, {
      type: 'melee',
      animation: 'dual_knives_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 42,
      walkSpeed: 0,
      rotationSpeed: 0,
      startNoise: 2,
      hitNoise: 5,
      range: 1.8,
      mul: { damage: 3, force: 4, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordMistwalker',
    emoji: '🗡️',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    demister: 5,
    PointLight: { color: '#7BCDFF', range: 6, intensity: 1 },
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [
      dmg({ slash: 75, frost: 40 }),
      dmg({ frost: 6, spirit: 5 }),
    ],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'sword_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 32,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.7,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'THSwordKrom',
    emoji: '🗡️',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.05,
    block: 52,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [
      dmg({ slash: 150 }),
      dmg({ slash: 6 }),
    ],
    knockback: 55,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'greatsword',
      chain: 3,
      chainCombo: 2,
      stamina: 20,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.6,
    }, {
      type: 'melee',
      animation: 'greatsword_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 40,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 3,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearCarapace',
    emoji: '🍢',
    tier: 6,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 45,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 115 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'spear_poke',
      chain: 0,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 1.9,
    }, {
      type: 'proj',
      animation: 'spear_throw',
      projVel: [2, 20],
      projAcc: [20, 1],
      stamina: 16,
      walkSpeed: 0.3,
      rotationSpeed: 5,
      startNoise: 10,
      hitNoise: 30,
      range: 1,
      mul: { damage: 1.5, force: 1.5, stagger: 1 },
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'SledgeDemolisher',
    emoji: '🔨',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.2,
    block: 56,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 145 }), dmg({ blunt: 6 })],
    knockback: 210,
    backstab: 2,
    attacks: [{
      type: 'area',
      animation: 'swing_sledge',
      stamina: 28,
      walkSpeed: 0.3,
      rotationSpeed: 0.1,
      startNoise: 10,
      hitNoise: 60,
      range: 2,
      mul: { damage: 1, force: 1, stagger: 2 },
      radius: 5,
    }],
    durability: [100, 50],
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldCarapaceBuckler',
    emoji: '🛡️',
    tier: 6,
    floating: true,
    stack: 1,
    maxLvl: 3,
    weight: 5,
    moveSpeed: -0.05,
    block: [78, 6],
    parryForce: [50, 5],
    parryBonus: 2.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldCarapace',
    emoji: '🛡️',
    tier: 6,
    floating: true,
    stack: 1,
    maxLvl: 3,
    weight: 5,
    moveSpeed: -0.05,
    block: [96, 6],
    parryForce: [60, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
// ASHLANDS
  {
    type: 'weapon', slot: 'both',
    id: 'StaffLightning',
    emoji: '⚡',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    // PointLight: { color: '#2AE2FF', range: 3, intensity: 1.5 },
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    damage: [dmg({ lightning: 20 }), dmg({ lightning: 3 })],
    knockback: 210,
    backstab: 1,
    attacks: [{
      type: 'proj',
      animation: 'recharge_lightningstaff',
      projVel: [0, 200],
      projAcc: [15, 0],
      number: 12,
      raiseSkillAmount: 0.1,
      stamina: 0,
      // reloadTime: 1.9
      eitr: 25,
      walkSpeed: 0.5,
      rotationSpeed: 1,
      startNoise: 15,
      hitNoise: 8,
      range: 2.4,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffClusterbomb',
    emoji: '🧨',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    // projectile: staff_clusterbombstaff_projectile
    // spawn on hit: staff_clusterbombstaff_splinter_projectile x12
    damage: [dmg({ blunt: 12, fire: 12 }), dmg({ fire: 6 })],
    toolTier: 5,
    knockback: 100,
    backstab: 1,
    attacks: [{
      type: 'proj',
      animation: 'staff_fireball',
      projVel: [2, 20],
      projAcc: [1, 0],
      number: 12,
      raiseSkillAmount: 0.1,
      stamina: 0,
      eitr: 30,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 0,
      hitNoise: 0,
      range: 1,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffRedTroll',
    emoji: '👹',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    // PointLight: { color: '#DC25E2', range: 4, intensity: 1 },
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.BloodMagic,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'summon',
      animation: 'staff_summon',
      stamina: 0,
      eitr: 120,
      healthPercent: 40,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
      summons: 'Troll_Summoned',
      skillFactor: 0.02,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffGreenRoots',
    emoji: '🌿',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    damage: [dmg({ blunt: 20, poison: 20 }), dmg({})],
    knockback: 30,
    backstab: 3,
    // staff_greenroots_projectile ->
    // staff_greenroots_spawn
    attacks: [{
      type: 'summon',
      summons: 'staff_greenroots_tentaroot',
      animation: 'staff_fireball',
      // projVel: [2, 20],
      // projAcc: [1, 0],
      skillFactor: 0.02,
      // raiseSkillAmount: 1,
      stamina: 0,
      eitr: 55,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 2.4,
    }],
    durability: [200, 50],
  },
  ...variations({
    type: 'weapon', slot: 'bow',
    id: 'BowAshlands',
    emoji: '🏹',
    tier: 7,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [dmg({ pierce: 82 }), dmg({ pierce: 4, spirit: 5 })],
    knockback: 25,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 60],
      projAcc: [20, 0],
      stamina: 0,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
    }],
    durability: [100, 50],
    holdDurationMin: 2.5,
    holdStaminaDrain: 14,
  }, {
    'BowAshlandsBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'BowAshlandsLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ pierce: 82, lightning: 10 }),
        dmg({ pierce: 4, spirit: 5 }),
      ],
    },
    'BowAshlandsNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ pierce: 82, poison: 10 }),
        dmg({ pierce: 4, spirit: 5 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'bow',
    id: 'CrossbowRipper',
    emoji: '🏹',
    tier: 7,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Crossbows,
    toolTier: 5,
    damage: [
      dmg({ pierce: 220 }),
      dmg({ pierce: 3 }),
    ],
    knockback: 210,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'crossbow_fire',
      projVel: [0, 200],
      projAcc: [0, 0],
      stamina: 0,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
      // blood: damageMultiplierPerMissingHP: 0.002
      // lightning: lightning dmg +30
      // nature: poison dmg +30, 15% to immobilize
    }],
    durability: [50, 50],
  }, {
    'CrossbowRipperBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'CrossbowRipperLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ pierce: 220, lightning: 10 }),
        dmg({ pierce: 3 }),
      ],
    },
    'CrossbowRipperNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ pierce: 220, poison: 10 }),
        dmg({ pierce: 3 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'primary',
    id: 'SpearSplitner',
    emoji: '🍢',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    toolTier: 5,
    damage: [ dmg({ pierce: 135 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'spear_poke',
      chain: 4,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 30,
      range: 1.9,
      // blood: damageMultiplierPerMissingHP: 0.002
      // lightning: lightning: blunt-10, lightning +10, spawnOnHit: AoE ChainLightning 20% (lightning: 75)
      // nature: pierce -10, poison +10, 15% to immobilize
    }, {
      type: 'proj',
      animation: 'spear_throw',
      projVel: [2, 20],
      projAcc: [20, 1],
      stamina: 18,
      walkSpeed: 0.3,
      rotationSpeed: 5,
      startNoise: 10,
      hitNoise: 30,
      range: 1,
      mul: { damage: 1.5, force: 1.5, stagger: 1, },
    }],
    durability: [100, 50],
  }, {
    'SpearSplitner_Blood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'SpearSplitner_Lightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ pierce: 135, lightning: 10 }),
        dmg({ pierce: 6, }),
      ],
    },
    'SpearSplitner_Nature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ pierce: 135, poison: 10 }),
        dmg({ pierce: 6, }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'primary',
    id: 'AxeBerzerkr',
    emoji: '🪓',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 6,
    damage: [
      dmg({ slash: 140, chop: 80 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 20,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'dualaxes',
      chain: 4,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.2,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
      // blood: damageMultiplierPerMissingHP: 0.002
      // lightning: lightning: blunt-10, lightning +10, spawnOnHit: AoE ChainLightning 20% (lightning: 75)
      // nature: pierce -10, poison +10, 15% to immobilize
    }, {
      type: 'melee',
      animation: 'dualaxes_secondary',
      chain: 0,
      chainCombo: 0,
      stamina: 28,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
      mul: { damage: 1.5, force: 1.5, stagger: 1, },
    }],
    durability: [175, 50],
  }, {
    'AxeBerzerkrBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'AxeBerzerkrLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ slash: 140, chop: 80, lightning: 10 }),
        dmg({ slash: 5, chop: 3 }),
      ],
    },
    'AxeBerzerkrNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ slash: 140, chop: 80, poison: 10 }),
        dmg({ slash: 5, chop: 3 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'primary',
    id: 'MaceEldner',
    emoji: '🍭',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    toolTier: 6,
    damage: [
      dmg({ blunt: 135 }),
      dmg({ blunt: 6 }),
    ],
    knockback: 100,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.2,
    }, {
      type: 'melee',
      animation: 'mace_secondary',
      chain: 0,
      chainCombo: 0,
      stamina: 28,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 2.5,
      mul: { damage: 2.5, force: 2, stagger: 2, },
    }],
    durability: [150, 50],
  }, {
    'MaceEldnerBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'MaceEldnerLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ blunt: 135, lightning: 10 }),
        dmg({ blunt: 5 }),
      ],
    },
    'MaceEldnerNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ blunt: 135, poison: 10 }),
        dmg({ pierce: 5 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'primary',
    id: 'SwordNiedhogg',
    emoji: '🗡️',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [dmg({ slash: 135 }), dmg({ slash: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
      // blood: damageMultiplierPerMissingHP: 0.002
      // lightning: blunt-10, lightning +10, spawnOnHit: AoE ChainLightning 20% (lightning: 75)
      // nature: blunt-10, poison +10, 15% to immobilize
    }, {
      type: 'melee',
      animation: 'sword_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 28,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.7,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  }, {
    'SwordNiedhoggBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'SwordNiedhoggLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ slash: 135, lightning: 10 }),
        dmg({ slash: 5 }),
      ],
    },
    'SwordNiedhoggNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ slash: 135, poison: 10 }),
        dmg({ slash: 5 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'both',
    id: 'THSwordSlayer',
    emoji: '🗡️',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.05,
    block: 64,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [
      dmg({ slash: 170 }),
      dmg({ slash: 6 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'greatsword',
      chain: 3,
      chainCombo: 2,
      stamina: 20,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.6,
    }, {
      type: 'melee',
      animation: 'greatsword_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 40,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 3,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  }, {
    'THSwordSlayerBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'THSwordSlayerLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ slash: 170, lightning: 10 }),
        dmg({ slash: 5 }),
      ],
    },
    'THSwordSlayerNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ slash: 170, poison: 10 }),
        dmg({ slash: 5 }),
      ],
    },
  }),
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordDyrnwyn',
    emoji: '🗡️',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    PointLight: { color: '#FF9300', range: 10, intensity: 1 },
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    toolTier: 6,
    damage: [
      dmg({ slash: 145, fire: 10 }),
      dmg({ slash: 6 }),
    ],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 16,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'sword_secondary',
      chain: 0,
      chainCombo: 0,
      stamina: 28,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.7,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldFlametal',
    emoji: '🛡️',
    floating: true,
    tier: 7,
    stack: 1,
    maxLvl: 3,
    variants: 5,
    weight: 5,
    moveSpeed: -0.05,
    block: [114, 6],
    parryForce: [50, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldFlametalTower',
    emoji: '🛡️',
    tier: 7,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 5,
    weight: 5,
    moveSpeed: -0.2,
    block: [140, 6],
    parryForce: [150, 5],
    parryBonus: 1,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
  {
    type: 'bomb', slot: 'primary',
    id: 'BombSiege',
    emoji: '💣',
    tier: 7,
    stack: 50,
    weight: 0.3,
    // toolTier: 6,
    spawns: 'siegebomb_explosion',
    // { pickaxe: 600 }
    stamina: 8,
  },
  {
    type: 'bomb', slot: 'primary',
    id: 'BombLava',
    emoji: '💣',
    tier: 7,
    stack: 50,
    weight: 0.3,
    // toolTier: 4,
    // projectile: lavabomb_projectile ->
      // TTL = 20
      // projVel: [2, 20],
      // projAcc: [20, 5],
    // lavabomb_explosion ->
    // spawnOnHitTerrain (Lava): lavabomb_rock1
    spawns: 'lavabomb_rock1',
    stamina: 8,
  },
  {
    type: 'bomb', slot: 'primary',
    id: 'BombSmoke',
    emoji: '💣',
    tier: 7,
    stack: 50,
    weight: 0.3,
    // projectile: smokebomb_projectile TTL = 20
    // projVel: [2, 20],
    // projAcc: [20, 5],
    // smokebomb_explosion
    // spawnOnHit: SmokeBallBomb
    spawns: 'SmokeBallBomb',
    stamina: 8,
  },
  // MISC
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordIronFire',
    emoji: '🗡️',
    disabled, // it's enabled, but recipe is disabled
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    // warmthRadius: 2,
    PointLight: { color: '#FF9E7B', range: 5, intensity: 2 },
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    toolTier: 0,
    damage: [
      dmg({ slash: 55, fire: 30 }),
      dmg({ slash: 5, fire: 6 }),
    ],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 14,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'sword_secondary',
      chain: 0,
      chainCombo: 0,
      stamina: 28,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.7,
      mul: { damage: 3, force: 1, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldKnight',
    emoji: '🛡️',
    disabled,
    tier: -1,
    floating: true,
    stack: 1,
    maxLvl: 1,
    weight: 4,
    moveSpeed: -0.05,
    block: [120, 6],
    parryForce: [40, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    knockback: 200,
    backstab: 4,
    durability: [100, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldIronSquare',
    emoji: '🛡️',
    disabled,
    tier: -1,
    floating: true,
    stack: 1,
    maxLvl: 3,
    weight: 4,
    moveSpeed: -0.2,
    block: [35, 6],
    parryForce: 30,
    parryBonus: 0,
    skill: SkillType.Blocking,
    knockback: 40,
    backstab: 4,
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordCheat',
    emoji: '🗡️',
    disabled,
    tier: -1,
    stack: 1,
    maxLvl: 1,
    weight: 2,
    moveSpeed: -0.05,
    block: 10,
    parryForce: 0,
    parryBonus: 2,
    skill: SkillType.Swords,
    toolTier: 10,
    damage: [dmg({
      slash: 10000,
      chop: 10000,
      pickaxe: 10000,
    }), dmg({
    })],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'melee',
      animation: 'swing_longsword',
      chain: 3,
      chainCombo: 2,
      stamina: 10,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 10,
      hitNoise: 40,
      range: 2.4,
    }, {
      type: 'melee',
      animation: 'sword_secondary',
      chain: 0,
      chainCombo: 0,
      stamina: 20,
      walkSpeed: 0.2,
      rotationSpeed: 0,
      startNoise: 10,
      hitNoise: 30,
      range: 2.7,
    }],
    durability: [100, 50], // useDurability: false
  },
  {
    type: 'weapon', slot: 'both',
    id: 'SledgeCheat',
    emoji: '🔨',
    disabled,
    tier: -1,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.2,
    block: 15,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Clubs,
    toolTier: 10,
    damage: [dmg({ /*damage: 99999, */ }), dmg({ blunt: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [{
      type: 'area',
      animation: 'swing_sledge',
      stamina: 25,
      walkSpeed: 0.3,
      rotationSpeed: 0.1,
      startNoise: 10,
      hitNoise: 60,
      range: 2,
      mul: { damage: 1, force: 1, stagger: 2 },
      radius: 5,
    }],
    durability: [100, 50],
  },
];

for (const item of items) {
  if (item.components == null) item.components = [];
  item.components.push('ItemDrop');
}

const enabledWeapons = items.filter(w => !w.disabled && w.type === 'weapon') as Weapon[]; 
export const axes = enabledWeapons.filter(w => w.damage[0].chop);
export const pickaxes = enabledWeapons.filter(w => w.damage[0].pickaxe);
